var map = {
	"./E-commerce.webp": 887,
	"./Encriptador.webp": 855,
	"./Relog-Digital.webp": 702,
	"./capmist-store.png": 691,
	"./coming-soon.webp": 727,
	"./portafolio.webp": 193,
	"./portafolioBlack.webp": 780,
	"./sal-y-piedra.png": 344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;